import { useEffect, useMemo, useState } from "react";

const parseLimitedLines = (value, maxLines) => {
  const lines = (value || "").split(/\r?\n/);
  return lines.slice(0, maxLines).join("\n");
};

export default function useProductListDraftInput({ storageKey, maxLines }) {
  const [value, setValue] = useState(() => {
    const savedValue = localStorage.getItem(storageKey) || "";
    return parseLimitedLines(savedValue, maxLines);
  });

  useEffect(() => {
    localStorage.setItem(storageKey, value);
  }, [storageKey, value]);

  useEffect(() => {
    setValue((currentValue) => parseLimitedLines(currentValue, maxLines));
  }, [maxLines]);

  const linesCount = useMemo(() => {
    return value.length ? value.split(/\r?\n/).length : 0;
  }, [value]);

  const updateValue = (nextValue) => {
    setValue(parseLimitedLines(nextValue, maxLines));
  };

  return {
    value,
    updateValue,
    linesCount,
  };
}
